"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_GAP_CHARACTER = exports.CARD_LOGO = exports.CARD_INPUT_PATTERN = void 0;
var CARD_INPUT_PATTERN = /[0-9]/;
exports.CARD_INPUT_PATTERN = CARD_INPUT_PATTERN;
var DEFAULT_GAP_CHARACTER = ' ';
exports.DEFAULT_GAP_CHARACTER = DEFAULT_GAP_CHARACTER;
var CARD_LOGO = {
  'american-express': 'AmexLogo',
  'big-pay': 'BigPayLogo',
  'ez-pay': 'EP',
  jcb: 'JcbLogo',
  mastercard: 'MasterCardLogo',
  visa: 'VisaBlueLogo',
  unionpay: 'UnionPayLogo',
  empty: ''
};
exports.CARD_LOGO = CARD_LOGO;